import request from '@/API/';

export default {
  getAppAlertingConfig: (payload) => {
    return request.get(`editor/${payload.clientHash}/apps/${payload.appHash}/alert`)
  },
  setAppAlertingConfig: (payload) => {
    return request.post(`editor/${payload.clientHash}/apps/${payload.appHash}/alert`, {
      alert: payload.alert,
      alert_config: payload.alert_config
    });
  },
  deleteGroup: (payload) => {
    if(payload.label) {
      return request.delete(`/editor/${payload.clientHash}/apps/${payload.appHash}/groups`, { "data": {
       "label": payload.label,
      }})
    }
  },
  saveGroup: (payload) => {
    /**
     * /editor/{clientHash}/apps/{appHash}/groups
     *
     * {
        "default": ["A012345567", "A123456789", "B123451234"]
       }
     */
    if(payload.sourceAndTarget) {
      const groupData = Object.assign({}, payload);
      delete groupData.clientHash;
      delete groupData.appHash;

      const data = groupData.sourceAndTarget;

      return request.post(`/editor/${payload.clientHash}/apps/${payload.appHash}/groups`, data)
    } else {
      console.log('call', payload);
      const groupData = Object.assign({}, payload);
      delete groupData.clientHash;
      delete groupData.appHash;
      return request.post(`/editor/${payload.clientHash}/apps/${payload.appHash}/groups`, groupData)
    }
  }
};
